var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 313,
    viewBox: "0 0 217 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3231 312.773C74.066 312.778 56.2175 307.368 41.0353 297.228C25.8532 287.088 14.0194 272.673 7.03049 255.807C0.0416185 238.94 -1.78825 220.38 1.77237 202.473C5.33299 184.567 14.124 168.119 27.0337 155.209C39.9434 142.299 56.3917 133.508 74.2982 129.947C92.2047 126.387 110.765 128.217 127.632 135.206C144.498 142.194 158.913 154.028 169.053 169.21C179.193 184.393 184.603 202.241 184.598 220.498C184.598 226.619 182.166 232.49 177.838 236.819C173.509 241.147 167.639 243.579 161.517 243.579H92.3231V197.465H132.205C128.151 190.467 122.327 184.66 115.318 180.625C108.308 176.591 100.361 174.471 92.2736 174.48C84.1862 174.489 76.2436 176.626 69.2434 180.677C62.2433 184.727 56.4319 190.548 52.3933 197.554C48.3547 204.561 46.2309 212.507 46.2352 220.595C46.2396 228.682 48.3721 236.626 52.4182 243.629C56.4643 250.631 62.2817 256.446 69.2862 260.488C76.2907 264.531 84.2356 266.659 92.3231 266.66V312.773Z",
    fill: "url(#paint0_linear_1562_3171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3004 114.825C113.757 114.825 131.152 97.4308 131.152 75.9737C131.152 54.5167 113.757 37.1223 92.3004 37.1223C70.8433 37.1223 53.449 54.5167 53.449 75.9737C53.449 97.4308 70.8433 114.825 92.3004 114.825Z",
    fill: "url(#paint1_linear_1562_3171)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.541 25.6657H191.551C191.54 25.6475 191.535 25.6269 191.535 25.6058C191.535 25.5848 191.54 25.5641 191.551 25.5458V12.5794C191.609 9.51405 190.529 6.53593 188.519 4.22067C186.509 1.9054 183.712 0.417456 180.669 0.0444101C179.011 -0.0987354 177.341 0.105057 175.766 0.642868C174.191 1.18068 172.746 2.04067 171.521 3.16806C170.297 4.29546 169.321 5.66556 168.655 7.19101C167.99 8.71646 167.649 10.3638 167.655 12.0282V25.6177V25.7376H154.377C151.312 25.6793 148.333 26.7594 146.018 28.7692C143.703 30.779 142.215 33.5758 141.842 36.6189C141.699 38.2771 141.903 39.9469 142.44 41.5219C142.978 43.097 143.838 44.5428 144.966 45.7672C146.093 46.9915 147.463 47.9676 148.989 48.6332C150.514 49.2988 152.161 49.6395 153.826 49.6333H167.415V62.6237C167.335 65.71 168.411 68.7149 170.434 71.0478C172.456 73.3806 175.278 74.8727 178.345 75.2306C180.003 75.3738 181.672 75.17 183.248 74.6322C184.823 74.0944 186.268 73.2343 187.493 72.1069C188.717 70.9795 189.693 69.6095 190.359 68.084C191.024 66.5586 191.365 64.9112 191.359 63.2468V49.6572H204.972C206.637 49.6634 208.284 49.3228 209.81 48.6572C211.335 47.9916 212.705 47.0154 213.832 45.7911C214.96 44.5667 215.82 43.121 216.358 41.5459C216.896 39.9709 217.099 38.301 216.956 36.6428C216.618 33.5989 215.159 30.7897 212.865 28.761C210.57 26.7323 207.604 25.6291 204.541 25.6657Z",
    fill: "url(#paint2_linear_1562_3171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1562_3171",
    x1: 0.024006,
    y1: 220.498,
    x2: 184.598,
    y2: 220.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1562_3171",
    x1: 53.449,
    y1: 75.9737,
    x2: 131.176,
    y2: 75.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1562_3171",
    x1: 141.866,
    y1: 37.6255,
    x2: 217.1,
    y2: 37.6255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.bc95f4373df645f209c889a6bd0f5880.svg";
export { ForwardRef as ReactComponent };